<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="column-container">
        <div class="header-row-container">
          <button
            type="button"
            class="ac-close-button"
            @click="toggleActionModal(false)"
          >
            <img
              src="@shared/assets/img/general/x-black.png"
              alt="x"
              class="ac-close"
            >
          </button>
          <div class="invite-header">
            SmartAC.com PRO App access
          </div>
        </div>
        <div class="see-more-details-container">
          <a
            href="/pro-app.pdf"
            target="_blank"
          >
            <span class="see-more-details-txt">See more details</span>
          </a>
        </div>
      </div>
      <img
        src="@shared/assets/img/general/pro-app-logo.svg"
        alt="pro-app-logo"
        class="pro-app-logo"
      >
    </div>
    <div class="ac-body-container">
      <form
        class="ac-image-upload-form"
        enctype="multipart/form-data"
      >
        <img
          v-if="!imagePreview"
          src="@shared/assets/img/tech/profile.png"
          alt="tech-illustration"
          class="tech-illustration"
        >
        <img
          v-else
          :src="imagePreview"
          alt="image-preview"
          class="image-preview"
        >
        <div class="ac-image-edit-container">
          <img
            src="@shared/assets/img/general/pencil-black.png"
            alt="Edit"
            class="edit-icon"
          >
        </div>
        <input
          id="file-input"
          ref="imageRef"
          type="file"
          class="db-input"
          accept="image/*"
          @change="selectedImage"
        >
        <div class="ac-image-edit-text">
          Add Photo
        </div>
      </form>
      <div class="row-container">
        <div class="invite-name-input-container">
          <div class="invite-input-label-container">
            <span class="invite-input-label-txt">Tech First Name:</span>
          </div>
          <SACInput
            placeholder="First Name"
            field="firstName"
            :value="firstName"
            :change="change"
            :error="error.firstName"
          />
        </div>
        <div class="invite-name-input-container">
          <div class="invite-input-label-container">
            <span class="invite-input-label-txt">Tech Last Name:</span>
          </div>
          <SACInput
            placeholder="Last Name"
            field="lastName"
            :value="lastName"
            :change="change"
            :error="error.lastName"
          />
        </div>
      </div>
      <div class="invite-input-container">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt"> Email </span>
        </div>
        <SACInput
          placeholder="Email"
          id="email"
          field="email"
          :value="email"
          :change="change"
          :error="error.email"
        />
      </div>
      <div class="invite-input-container">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt"> Phone </span>
        </div>
        <SACInput
          type="number"
          restrict="phone-number"
          placeholder="Phone"
          field="phone"
          :value="phone"
          :change="change"
          :error="error.phone"
        />
      </div>
      <div v-if="partnerOptions.length" class="invite-input-container">
        <div class="invite-input-label-container">
          <span class="invite-input-label-txt"> Partner </span>
        </div>
        <SACDropdown
          :showSearch="true"
          placeholder="Select partner"
          field="partner"
          :value="partner"
          :options="partnerOptions"
          :change="change"
          :error="error.partner"
        />
      </div>
      <div class="invite-input-container">
        <SACCheckbox
          label="Non-Installer (exclude from installation reporting)"
          :checked="nonInstaller"
          field="nonInstaller"
          :change="(field) => change(field, !nonInstaller)"
        />
      </div>
      <div class="invite-input-container">
        <SACRadio
          field="createPassword"
          :value="false"
          :checked="createPassword === false"
          :change="change"
          label="Ask user to set password when they sign in"
        />
      </div>
      <div class="invite-input-container">
        <SACRadio
          field="createPassword"
          :value="true"
          :checked="createPassword === true"
          :change="change"
          label="Create Password"
        />
      </div>
      <div
        v-if="createPassword"
        class="invite-input-container"
      >
        <input
          id="password"
          v-model="techPassword"
          :type="inputType"
          class="p-input"
          autocomplete="false"
        >
        <div class="pwd-visibility">
          <img
            v-if="showPassword"
            class="eyeball-img"
            src="@shared/assets/img/general/show-password.png"
            alt="show-password"
            @click="toggleVisibility()"
          >
          <img
            v-else
            class="eyeball-img"
            src="@shared/assets/img/general/hide-password.png"
            alt="hide-password"
            @click="toggleVisibility()"
          >
        </div>
        <span
          v-if="error.password"
          class="password-error"
        >
          {{ error.password[0] }}
        </span>
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="inviteTech"
      >
        Invite
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>
<script>
import technicianMixin from '@shared/mixins/technicianMixin';
import errorCatch from '@shared/lib/errorCatch/passwordValidation';
import SACInput from '@shared/components/sac/SACInput.vue';
import SACDropdown from '@shared/components/sac/SACDropdown.vue';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import SACCheckbox from '@shared/components/sac/SACCheckbox.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

import formatPhoneNumber from '@shared/lib/formatter/formatPhoneNumber';
import emailValidation from '@shared/lib/errorCatch/emailValidation';
import phoneValidation from '@shared/lib/errorCatch/phoneValidation';
import { mapState } from 'vuex';

export default {
  name: 'InviteTechnician',
  components: {
    SACInput,
    SACDropdown,
    SACRadio,
    SACCheckbox,
    ProcessOverlay,
  },
  computed: {
    ...mapState({
      adminFilter: (state) => state.admin.adminFilter,
    }),
  },
  mixins: [technicianMixin],
  data() {
    return {
      loading: false,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      partner: 0,
      techPassword: '',
      imagePreview: '',
      createPassword: false,
      showPassword: false,
      inputType: 'password',
      nonInstaller: false,
      error: {},
      processing: false,
    };
  },
  mounted() {
    if (this.adminFilter.corpId) {
      this.partner = this.adminFilter.corpId;
    }
  },
  methods: {
    change(field, value) {
      let v = value;
      if (field === 'phone') {
        v = formatPhoneNumber(value);
      }
      this[field] = v;
    },
    selectedImage() {
      const image = this.$refs.imageRef.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.imagePreview = e.target.result;
      };
      const payload = {
        image,
      };
      this.selectImage(payload);
    },
    toggleVisibility() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.inputType = 'text';
      } else {
        this.inputType = 'password';
      }
    },
    async inviteTech() {
      const {
        corpId,
      } = this.adminFilter;
      const errObj = {};
      const passwordErrs = [];
      if (!this.firstName && (this.firstName && !this.firstName.trim())) {
        errObj.firstName = 'Please enter the tech\'s first name';
      }
      if (!this.lastName && (this.lastName && !this.lastName.trim())) {
        errObj.lastName = 'Please enter the tech\'s last name';
      }
      if (!this.email && (this.email && !this.email.trim())) {
        errObj.email = 'Please enter the tech\'s email';
      } else if (!emailValidation(this.email)) {
        errObj.email = 'Email is not valid';
      }
      if (!this.phone && (this.phone && !this.phone.trim())) {
        errObj.phone = 'Please enter the tech\'s phone number';
      } else if (!phoneValidation(this.phone)) {
        errObj.phone = 'Phone number is not valid';
      }
      if (this.corpOptions.length > 0 && this.partner === 0) {
        errObj.partner = 'Please select a partner';
      }
      if (this.createPassword && !this.techPassword.trim()) {
        errObj.password = ['Please enter the tech\'s password'];
      }
      if (this.createPassword && this.techPassword) {
        const passwordStrength = errorCatch(this.techPassword);
        if (passwordStrength) {
          passwordStrength.forEach((ps) => {
            if (ps === 'min'
              || ps === 'uppercase'
              || ps === 'digits'
              || ps === 'spaces'
            ) {
              passwordErrs.push('Please include 8 characters, a capital letter, and a number.');
            }
          });
        }
        if (passwordErrs.length > 0) {
          errObj.password = passwordErrs;
        }
      }
      this.error = errObj;
      if (Object.keys(this.error).length === 0) {
        const tech = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          password: this.techPassword || null,
          corporationId: this.partner || corpId,
          adminId: this.currentAdmin.id,
          createPassword: !this.createPassword,
          nonInstaller: this.nonInstaller,
        };
        this.processing = true;
        try {
          await this.$store.dispatch('inviteTech', tech);
          this.toggleActionModal(false);
        } catch (err) {
          if (err && err.response && err.response.data) {
            const {
              message,
            } = err.response.data;
            if (message.includes('already exists')) {
              errObj.email = message;
            }
            this.error = errObj;
          }
        }
        this.processing = false;
      } else {
        document.getElementById('email').scrollIntoView();
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.pro-app-logo {
  width: 54px;
  height: 55px;
  margin-left: auto;
}

.invite-header {
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}

.header-row-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.see-more-details-container {
  margin-left: auto;
}

.see-more-details-txt {
  text-decoration: underline;
}

.image-preview-container {
  width: 100%;
  height: 100%;
  border-radius: 10px;
  position: relative;
}

.edit-photo {
  margin-top: 100px;
  width: 129px;
  position: absolute;
}

.row-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
}

.column-container {
  display: flex;
  flex-direction: column;
}

.invite-name-input-container {
  width: 50%;
  height: 100%;

  &:nth-child(2) {
    margin-left: 15px;
  }
}

.invite-input-container {
  position: relative;
  margin-bottom: 20px;
}

.invite-input-label-container {
  margin-bottom: 15px;
  // padding-left: 15px;
}

.invite-input-label-txt {
  font-size: 18px;
  font-weight: 500;
}

/* On mouse-over, add a grey background color */
.container:hover input~.checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked~.checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked~.checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
}

.ac-image-upload-form {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-bottom: 28px;

  .ac-image-edit-text {
    font-size: 1.125rem;
    color: $BLACK;
    font-weight: 600;
    margin-left: -8px;
  }

  #file-input {
    cursor: pointer;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 180px;
    height: 180px;
  }

  .tech-illustration {
    width: 150px;
    height: 150px;
    object-fit: contain;
  }

  .image-preview {
    width: 180px;
    height: 180px;
    border-radius: 50%;
    object-fit: cover;
  }

  .ac-image-edit-container {
    position: absolute;
    bottom: 0;
    left: 100px;
    width: 30px;
    height: 30px;
    padding: 2px;
    border-radius: 4px;
    background-color: $NBLUE100;
    display: flex;
    align-items: center;
    justify-content: center;

    .edit-icon {
      width: 100%;
    }
  }
}

.radio-label {
  margin-left: 5px;
}

.p-input {
  border: 1px solid $N10;
  width: 100%;
  height: 45px;
  border-radius: 5px;
  padding: 0 10px;

  &:focus {
    background-color: $NBLUE10;
  }

  @media (max-width: 420px) {
    height: 35px;
  }
}

.pwd-visibility {
  position: absolute;
  right: 10px;
  top: 15px;

  @media (max-width: 420px) {
    top: 35px;
  }

  .eyeball-img {
    height: 20px;
    width: 20px;
    cursor: pointer;

    @media (max-width: 420px) {
      height: 15px;
      width: 15px;
    }
  }
}

.password-error {
  color: $TOMATO100;
  font-size: 0.875rem;
  font-weight: 500;
  margin-top: 5px;

  @media (max-width: 420px) {
    font-size: 0.75rem;
  }
}
</style>
